import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AddProduct from "./Components/AddProducts";
import CheckOut from "./Components/CheckOut";
import Header from "./Components/Header";
import Login from "./Components/Login/Login";
import SignUp from "./Components/Login/SignUp";
import { auth, db } from "./Config/Config";

import Aos from "aos";
import "aos/dist/aos.css";

import "./default.scss";
import AboutPage from "./Pages/About";
import BlogPage from "./Pages/Blogs";

import { useStateValue } from "./Components/StateProvider";

import Home from "./Pages/Home";
import Payment from "./Components/Payment";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "./Components/Orders";
import FruitsPage from "./Pages/Fruits";
import VegetablePage from "./Pages/Vegetables";
import MeatPage from "./Pages/Meat&Fish";
import SnacksPage from "./Pages/Snacks";
import DairyPage from "./Pages/Dairy";
import MasalaPage from "./Pages/Masala";
import Footer from "./Components/Footer";
import ProductDetails from "./Components/ProductDetails";
import Contact from "./Pages/Contact";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchProduct from "./Pages/SearchProduct";

toast.configure();


const promise = loadStripe(
  "pk_test_51In0jAGABSws1hjGcaNoO8WI99JpAc6ZKwaWNnDdfKR6XuXgK9iLYEwdPw6MlcdQkJLRRtQ0K10Iy2kJHC1XttlH008UZ2PbQq"
);

function App() {
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userauth) => {
      if (userauth) {
        dispatch({
          type: "SET_LOGIN",
          user: userauth,
        });
      } else {
        dispatch({
          type: "SET_LOGIN",
          user: null,
        });
      }
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    Aos.init({duration:1000});
  }, []);

  return (
    <>
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact>
            <Header />
            <AboutPage />
            <Footer />
          </Route>
          <Route path="/blogs" exact>
            <Header />
            <BlogPage />
            <Footer />
          </Route>
          <Route path="/addproduct" exact component={AddProduct} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/signup" exact component={SignUp} />
          <Route path="/login" exact component={Login} />
          <Route path="/checkout" exact>
            <Header /> <CheckOut />
          </Route>

          <Route path="/productdetails" exact>
            <Header />
            <ProductDetails />
          </Route>
          <Route path="/payment" exact>
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>

          <Route path="/orders" exact>
            <Header />
            <Orders />
          </Route>

          {/* Category pages  */}
          <Route path="/category/Fruits" exact>
            <FruitsPage />
          </Route>

          <Route path="/category/Vegetables" exact>
            <VegetablePage />
          </Route>

          <Route path="/category/Meat and Fish" exact>
            <MeatPage />
          </Route>

          <Route path="/category/Snacks" exact>
            <SnacksPage />
          </Route>

          <Route path="/category/Dairy and Milk" exact>
            <DairyPage />
          </Route>

          <Route path="/category/Oil and Masala" exact>
            <MasalaPage />
          </Route>

          <Route path="/SearchProducts" exact>
            <SearchProduct/>
          </Route>
        
        </Switch>
      </Router>

    </>
  );
}

export default App;
